<BolideLoader v-show="is_loading" :is_visible="is_loading" />

<div class="dashboard-container container-fluid px-0" v-show="!is_loading">
    <div class="row g-0 vh-100 overflow-hidden">

        <!-- ======= SIDEBAR AREA (DESKTOP ONLY) ======= -->
        <div v-if="!is_mobile"
            class="col-auto sidebar-wrapper sidebar-offset d-flex flex-column flex-shrink-0 position-sticky top-0 vh-100 overflow-hidden overflow-x-visible"
            :class="{ 'sidebar-collapsed': sidebar_collapsed }">
            <!-- DESKTOP SIDEBAR SCROLL AREA -->
            <div class="h-100 overflow-auto overflow-x-hidden no-scrollbar">
                <!-- ===== PORTFOLIO MODE ===== -->
                <PortfolioSidebar v-if="!is_property_view && can_view_portfolio" :tiles="tiles"
                    :current_active_property="selected_property?.title" :active_item="active_menu_item"
                    @tile-clicked="handleTileClick" @global-menu-selected="handleGlobalMenuSelected"
                    @property-menu-selected="handlePropertyMenuSelected" @global-selected="goBack" />

                <!-- ===== PROPERTY MODE ===== -->
                <PropertySidebar v-else-if="selected_property" :active_property="selected_property" :properties="tiles"
                    :active_item="active_menu_item" :can_view_portfolio="can_view_portfolio"
                    @switch-property="handleTileClick" @go-back="goBack"
                    @property-menu-selected="handlePropertyMenuSelected" />
            </div>
        </div>

        <!-- ======= MOBILE SIDEBAR OVERLAY ======= -->
        <div v-if="is_mobile && mobile_sidebar_open" class="mobile-sidebar-overlay" @click.self="close_sidebar">
            <div class="mobile-sidebar-panel h-100 overflow-hidden">
                <div class="h-100 overflow-auto overflow-x-hidden">
                    <!-- ===== PORTFOLIO MODE ===== -->
                    <PortfolioSidebar v-if="!is_property_view && can_view_portfolio" :tiles="tiles"
                        :current_active_property="selected_property?.title" :active_item="active_menu_item"
                        @tile-clicked="handleTileClick" @global-menu-selected="handleGlobalMenuSelected"
                        @property-menu-selected="handlePropertyMenuSelected" @global-selected="goBack"
                        @close-sidebar="close_sidebar">
                        <template #sidebar-header-actions>
                            <button class="sidebar-close-btn" @click="close_sidebar" aria-label="Close sidebar">
                                <i class="bi bi-x-lg"></i>
                            </button>
                        </template>
                    </PortfolioSidebar>

                    <!-- ===== PROPERTY MODE ===== -->
                    <PropertySidebar v-else-if="selected_property" :active_property="selected_property"
                        :properties="tiles" :active_item="active_menu_item"
                        :can_view_portfolio="can_view_portfolio" @switch-property="handleTileClick"
                        @go-back="goBack" @property-menu-selected="handlePropertyMenuSelected"
                        @close-sidebar="close_sidebar">
                        <template #sidebar-header-actions>
                            <button class="sidebar-close-btn" @click="close_sidebar" aria-label="Close sidebar">
                                <i class="bi bi-x-lg"></i>
                            </button>
                        </template>
                    </PropertySidebar>
                </div>
            </div>
        </div>

        <!-- ======= SIDEBAR COLLAPSE BUTTON ======= -->
        <button v-if="!is_mobile" class="sidebar-collapse-btn btn btn-sm btn-dark float-start" @click="toggleSidebar">
            <i :class="sidebar_collapsed ? 'bi bi-chevron-double-right' : 'bi bi-chevron-double-left'"></i>
        </button>

        <!-- ======= MAIN CONTENT AREA ======= -->
        <div class="col vh-100 d-flex flex-column overflow-hidden no-scrollbar">
            <!-- HEADER -->
            <HeaderSection :breadcrumb="breadcrumb" @breadcrumb-click="handleBreadcrumbClick"
                @open-assistant="showAssistant = true" @toggle-mobile-sidebar="toggle_mobile_sidebar">
                <template #breadcrumb-extra>

            <!-- ⭐ MANAGEMENT CONTACT -->
            <div v-if="management_contact" class="d-flex flex-wrap align-items-center p-0 m-0 row-gap-1 management-color">
                <p class="text-xs me-2 text-white-50 mb-0">
                    {{ management_contact.role }} :
                </p>

                <p class="text-xs me-2 fw-semibold mb-0">
                    {{ management_contact.full_name }}
                </p>

                <p class="text-xs me-2 mb-0">
                    {{ management_contact.phone }}
                </p>

                <p class="text-xs me-2 mb-0">
                    {{ management_contact.email }}
                </p>
            </div>
                </template>
            </HeaderSection>

            <BolideAssistant
                :is_open="showAssistant"
                :scope="assistant_scope"
                :compare_property_options="comparison_property_options"
                :compare_property_ids="selected_compare_property_ids"
                @update:compare_property_ids="selected_compare_property_ids = $event"
                @close-assistant="showAssistant = false"
            />

            <!-- MAIN SCROLL AREA -->
            <main class="dashboard-main flex-grow-1 overflow-auto overflow-x-hidden"
                :class="{ 'dashboard-main-assist-open': showAssistant }">
                <!-- ================= MAIN VIEW (GLOBAL) ================= -->
                <div v-if="currentView === 'main'" class="dashboard-main-view h-100">
                    <div class="row g-0 h-100">
                        <PortfolioSuperSetChart :content_class="getMainContentClass()" chart_id="dashboard-main"
                            :iframe_loading="iframeLoading" />
                    </div>
                </div>

                <div v-else-if="currentView === 'no-assigned-properties'" class="d-flex align-items-center justify-content-center h-100 p-4">
                    <div class="glass-card rounded-4 text-center p-4">
                        <h5 class="text-white fw-bold mb-2">No properties assigned</h5>
                        <p class="text-white-50 text-xs mb-0">
                            Ask an administrator to assign properties to this user.
                        </p>
                    </div>
                </div>

                <!-- ============== PROPERTY VIEW ============== -->
                <div v-else-if="is_property_view && !isDetailView(currentView)"
                    class="dashboard-property-view h-100 d-flex flex-column">
                    <!-- PROPERTY OVERVIEW -->
                    <div class="mb-3">
                        <PropertyOverview v-if="selected_property" :centre="selected_property.propertyOverview || {
                                title: selected_property.title,
                                size: 'N/A',
                                occupancy: 'N/A',
                                description: selected_property.description || 'Property'
                            }" :total_centres="selected_property.propertyOverview?.total_centres || tiles.length" />
                    </div>

                    <!-- PROPERTY CONTENT SCROLL AREA -->
                    <div class="property-dashboard-shell flex-grow-1 overflow-auto overflow-x-hidden pe-1">
                        <div class="card rounded-3 bg-transparent border-0 h-100">
                            <div
                                class="property-dashboard-content p-3 h-100"
                                :class="{
                                    'operations-dashboard-content': active_menu_item === 'operations-overview'
                                }"
                            >
                                    <!-- Superset Dashboard -->
                                    <div
                                        class="portfolio-chart property-portfolio-chart mb-0"
                                        :class="{ 'operations-superset-panel': active_menu_item === 'operations-overview' }"
                                    >
                                        <div
                                            class="superset-embedded-container property-superset-container m-0 p-0"
                                            :class="{ 'operations-superset-container': active_menu_item === 'operations-overview' }"
                                        >
                                            <div :id="'dashboard-' + currentView"></div>

                                            <div v-if="iframeLoading" class="iframe-loading text-center py-3">
                                                <div class="spinner-border spinner-border-sm me-2"></div>
                                                Loading embedded dashboard...
                                            </div>

                                            <div v-if="iframeError" class="error-message mt-2 text-danger text-center">
                                                Failed to load dashboard. Please try refreshing.
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Emergency / Operations Overview Extras -->
                                    <template v-if="active_menu_item === 'operations-overview'">
                                        <div class="operations-overview-stack">
                                            <template v-for="tileCard in getTileCards()" :key="tileCard.id">
                                                <EmergencyContactMap v-if="tileCard.type === 'emergency-map'"
                                                    :location-name="tileCard.locationName || getCurrentTitle()"
                                                    :property-coordinates="selected_property?.coordinates"
                                                    :municipality="getPropertyMunicipality()"
                                                    :water-utility="getPropertyWaterUtility()"
                                                    :tariff-regime="getPropertyTariffRegime()"
                                                    :selected-property="selected_property" />
                                            </template>

                                            <SecurityDemographicsCompetition :crimeStats="currentCrimeStats" />
                                        </div>
                                    </template>
                            </div>
                        </div>
                    </div>

                    <!-- RIGHT SIDEBAR / EXTRA PANELS -->
                    <div v-if="hasTileCards() && showRightPanel">
                        <template v-for="tileCard in getTileCards()" :key="tileCard.id">
                            <!-- render right-side widgets here when needed -->
                        </template>
                    </div>
                </div>

                <!-- ============== DETAIL VIEW ============== -->
                <div v-else-if="isDetailView(currentView)" class="dashboard-detail-view">
                    <div class="card rounded-3 bg-transparent border mt-4 mb-4">
                        <div class="portfolio-chart">
                            <div class="superset-embedded-container m-0 p-0">
                                <div :id="'dashboard-' + currentView"></div>

                                <div v-if="iframeLoading" class="iframe-loading">
                                    <div class="spinner-border spinner-border-sm me-2"></div>
                                    Loading embedded dashboard...

                                    <div v-if="iframeError" class="error-message mt-2 text-danger">
                                        Failed to load dashboard. Please try refreshing.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </main>

            <!-- 🤖 FLOATING ASSISTANT (MOBILE) -->
            <button v-if="is_mobile && !showAssistant" class="floating-assistant-btn btn btn-primary d-md-none"
                @click="showAssistant = true" aria-label="Open assistant">
                <i class="bi bi-robot fs-5"></i>
            </button>
        </div>
    </div>
</div>
